import * as React from 'react';

import qs from 'qs';
import { withRouter } from 'react-router-dom';

import { Loader } from 'components/loader/Loader';

import { fetchEagleJwt, mockLogin } from './Login.connector';
import { IProps } from './Login.types';

export class LoginRaw extends React.Component<IProps> {
  public async componentDidMount(): Promise<void> {
    const queryParams = qs.parse(window.location.search, {
      ignoreQueryPrefix: true,
    });

    const { code, mock, redirect } = queryParams;

    if (!code) {
      this.props.history.replace(`/${redirect ? `?redirect=${redirect}` : ''}`);
      return;
    }

    try {
      if (mock) {
        await mockLogin(code);
      } else {
        await fetchEagleJwt(code);
      }

      this.props.history.replace(atob(redirect));
    } catch (e) {
      this.props.history.replace(`/?error=403&redirect=${redirect}`);
    }
  }

  public render() {
    return <Loader />;
  }
}

const Login = withRouter(LoginRaw);

export { Login };
